import filterQuestionnaireResponses from './filterQuestionnaireResponses'
import formatQuestionnaireResponses from './formatQuestionnaireResponses'

// Turns raw custom question form values into the payload the question responses endpoint
// expects. Photo answers and blank optional answers are dropped, because photos are
// uploaded separately as they are picked.
export default function prepareQuestionResponses(
  questionResponses,
  questions,
  trip
) {
  const filteredResponses = filterQuestionnaireResponses(
    questionResponses,
    questions
  )

  return formatQuestionnaireResponses(filteredResponses, questions, trip)
}
